import imagesLoaded from "imagesloaded";
import { gsap } from "gsap";

import { header_init } from "@/js/share/components/_header";

/**
 * 初始化圖片加載監聽器
 * @param {Function} callback 當所有圖片加載完成後執行的回調函式
 */

export function init_imageloaded(callback) {
    imagesLoaded("html, body", function () {

        gsap.to(".loading", { duration: 0.3, opacity: 0, display: "none" });

        header_init();

        if (typeof callback === "function") {
            callback();
        }
    });
}